import EntityListContainer from './EntityListContainer'
import EntityDetail from './EntityDetail'
import { setDomains } from './AclDataProvider/actions'
import { Detail, Spaces, Users, Roles } from './DetailPanels'
import { Globe } from 'react-feather'
import { Tag } from 'antd'
import ACLService from 'Services/ACL_Service'

getUsers = (domain) ->
  (await Weaver.User.list()).filter((user) ->
    user.id() in domain.getUsers()
  )

addUser = (domain, user) ->
  domain.addUser(user)
  await domain.save()
  user

removeUser = (domain, user) ->
  domain.removeUser(user)
  domain.save()

getSpaces = (domain) ->
  Promise.filter(await Weaver.Project.list(), (space) ->
    if (await space.getACL()).getRoleReadAccess(domain)
      getPermissions(domain, space)
    else
      false
  )

getPermissions = (domain, space) ->
  space.acl = await space.getACL()
  space.hasReadAccess = space.acl.getRoleReadAccess(domain)
  space.hasReadAccess

addSpace = (domain, space) ->
  space.acl = await space.getACL()
  space.acl.setRoleReadAccess(domain, true)
  await space.acl.save()
  await getPermissions(domain, space)
  space

removeSpace = (domain, space) ->
  space.acl.setRoleReadAccess(domain, false)
  space.acl.save()

export DetailView = EntityDetail({
  getItem: (id) ->
    if id is 'new'
      domain = new Weaver.Domain('new-domain')
      domain.isCreating = true
      domain
    else
      (await Weaver.Domain.list()).find((domain) ->
        domain.id() is id
      )
  icon: 'globe'
  title: (domain) -> domain.name()
  tabs: [{
    title: 'Domain Detail'
    Component: Detail({
      displayName: (item) -> item.name()
      fields: () -> [{ field: '_name', label: 'Name' }]
    })
  }, {
    title: 'Members'
    Component: Users({ getUsers, addUser, removeUser })
  }, {
    title: 'Spaces'
    Component: Spaces({ getSpaces, addSpace, removeSpace })
  }]
})

export ListView = EntityListContainer({
  title: 'Domains'
  singular: 'domain'
  singularRoute: 'domains'
  canDelete: false
  Icon: Globe
  init: ->
    domains = await Weaver.Domain.list()
    setDomains(domains)
  reducerKey: 'domains'
  filterer: (str) -> (item) -> item.name().toLowerCase().indexOf(str.toLowerCase()) isnt -1
  itemProps: {
    title: (item) -> item.name()
    description: (item) -> item.listUsers().length + ' active users'
    titleExtra: (item) ->
      <>
        {
          if item.active
            <Tag color="blue">Active</Tag>
          else
            <Tag color="red">Inactive</Tag>
        }
      </>
    key: (item) -> item.id()
  }
  actions: [
    {
      content: (item) -> item.active && 'Deactivate' || 'Activate'
      fn: (item) ->
        if item.active
          fn = 'deactivate'
        else
          fn = 'activate'
        item[fn]()
        await item.save()
      accessFn: (item) -> ACLService.hasWriteAccess()
    }
  ]
})
